import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const LifeTags = () => {
     useEffect(() => {
        document.title = 'Life Tags -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
     <li>Gallery</li>
    <li>   Video Gallery  </li> 
     <li>Life Tags </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Life Tags  </h1>
         </div>
     </div>
     <div className="row">
     <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">
      <iframe width="100%" height="200" src="https://www.youtube.com/embed/b--1eCrkzIk?si=R10Fw34fxdcfm43R" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <div> 
              <h3>Wisdom Over Knowledge</h3> 
          </div>  
       </div>
    </div>
    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">
      <iframe width="100%" height="200" src="https://www.youtube.com/embed/fn9rlLcZBn4?si=thWN8-sTHgMA770E" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <div> 
              <h3>Self Awareness</h3> 
          </div>  
       </div>
    </div>
    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">
      <iframe width="100%" height="200" src="https://www.youtube.com/embed/Tuy4M5qixNE?si=94nJ5cEewFPekxEq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <div> 
              <h3>Confidence</h3> 
          </div>  
       </div>
    </div>
    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">
      <iframe width="100%" height="200" src="https://www.youtube.com/embed/B3ffYBwvF_U?si=0O2THvkgczEn8QaK" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <div> 
              <h3>Freedom</h3> 
          </div>  
       </div>
    </div>
    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">
      <iframe width="100%" height="200" src="https://www.youtube.com/embed/QJM_vGPRuGA?si=_D5d9rc6I9kH7U7_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <div> 
              <h3>"खुद पर विश्वास"</h3> 
          </div>  
       </div>
    </div>
    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">
      <iframe width="100%" height="200" src="https://www.youtube.com/embed/dCzciVTOFtw?si=R0RUSAuEBIxCoChk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <div> 
              <h3>Power Of Words</h3> 
          </div>  
       </div>
    </div>
    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">
      <iframe width="100%" height="200" src="https://www.youtube.com/embed/UbvHtDI_CYA?si=Mzu9RJvn36cy1vZ0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <div> 
              <h3>Building Strong Habits</h3> 
          </div>  
       </div>
    </div>
    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">
      <iframe width="100%" height="200" src="https://www.youtube.com/embed/JpgY-h3UnXc?si=1OdWxFpkGI5ZLFK9" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <div> 
              <h3>Passion & Purpose</h3> 
          </div>  
       </div>
    </div>
    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">
      <iframe width="100%" height="200" src="https://www.youtube.com/embed/uRlExU-J9oQ?si=7Fqmdp2RJdud38o1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <div> 
              <h3>Time Management</h3> 
          </div>  
       </div>
    </div>
    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">
      <iframe width="100%" height="200" src="https://www.youtube.com/embed/C3OuzAZ8Coc?si=n2k6r9s4b4NXgSzs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <div> 
              <h3>Motivational talk by students</h3> 
          </div>  
       </div>
    </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default LifeTags
